<script lang="ts" setup></script>

<template>
  <h6 class="subtitle">
    <slot />
  </h6>
</template>

<style lang="postcss" scoped>
  .subtitle {
    @apply text-lg font-bold;
  }
</style>
